import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ConfigService } from 'projects/patient/src/app/core/auth/services/config.service';
import { LocalStorageService } from 'projects/patient/src/app/core/auth/services/local-storage.service';
import { DocumentResponse, PreAssessmentResponse } from '../../user-const/user-model';

import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DietSummaryService {
  http = inject(HttpClient);
  hostUrl = inject(ConfigService).getAPIUrl(); // v2 api url
  patientHostUrl = inject(ConfigService).getPatientAPIUrl(); //dev api url
  localStorageService = inject(LocalStorageService);
  constructor() {}

  getAssessmentSummary(patientId: string, paging: any): Observable<PreAssessmentResponse> {
    return this.http.get<PreAssessmentResponse>(`${this.hostUrl}/api/PreAssessment/${patientId}`, {
      params: paging,
    });
  }

  getSingleAssessmentDietSummary(patientId: string, paging: any, assessmentId: string): Observable<DocumentResponse> {
     let params: any = {
    ...paging,
    document_type: 2,
    filter: `pre_assessment_id eq ${assessmentId}`
  };

    return this.http.get<DocumentResponse>(`${this.hostUrl}/api/Patient/${patientId}/history?document_type=2`, {
      params: params,
    });
  }
}
